<div class="swiper-container">
	<div class="swiper-wrapper">
		<div class="swiper-slide" *ngFor="let image of imagesList">
			<div class="plate plate--masthead default">
				<ng-container *ngIf="image.video_id">
					<img *ngIf="image.image_path" [src]="baseUrl + image.image_path" alt="Image">
					<div class="icon icon--play main-work__play" (click)="playVideo(image.video_id, image.video_type)"></div>
				</ng-container>
				<ng-container *ngIf="!image.video_id">
					<img *ngIf="image.image_path" [src]="baseUrl + image.image_path" alt="Image">
				</ng-container>
			</div>
		</div>
	</div>
</div>
